module.exports = __webpack_public_path__ + "static/media/chrome-icon.1662ed22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chrome-icon.png
// module id = 245
// module chunks = 0